import { Component, Input, OnInit } from "@angular/core";
import { Clipboard } from "@ionic-native/clipboard/ngx";
import { GlobalsService } from "src/app/api/globals.service";
import { ToastService } from "src/app/services/toast.service";
import * as jQuery from "jquery";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import {
  AlertController,
  IonicSafeString,
  ToastController,
} from "@ionic/angular";
import { CursosService } from "src/app/services/cursos.service";
import { ActivatedRoute } from "@angular/router";
import { AuthService } from "src/app/services/auth.service";
import { ActividadesService } from "src/app/services/actividades.service";
import { environment } from "src/environments/environment";
@Component({
  selector: "app-presentacion",
  templateUrl: "./presentacion.component.html",
  styleUrls: ["./presentacion.component.scss"],
})
export class PresentacionComponent implements OnInit {
  @Input() public curso: any;
  @Input() public DATA_LIBRO: any;
  @Input() public DATA_CURSO: any;
  rutaRef: string;
  urlEncode: any;
  publico: number = 1;
  activarContrasena: number = 1;
  argumentos = null;
  displayUserData: any;
  auth_key: string;
  id: number;
  passwordCourse: string = "";

  ACTIVIDADES: any = [];
  ACTIVIDAD_CURSO: any = [];
  CONTINUE: number;
  showPassword: any;
  dataLoaded =false;
  constructor(
    private clipboard: Clipboard,
    public toastService: ToastService,
    public globalsService: GlobalsService,
    private sanitizer: DomSanitizer,
    private cursosService: CursosService,
    private activeRoute: ActivatedRoute,
    private authService: AuthService,
    public actividadesService: ActividadesService,
    public alertController: AlertController
  ) {
    this.argumentos = this.activeRoute.snapshot.paramMap.get("id_curso");
  }
  loadUserData() {
    let promise = new Promise((resolve) => {
      this.authService.userData$.subscribe((res: any) => {
        if (res) {
          if (!this.displayUserData) {
            this.displayUserData = res;
            resolve(true);
          }
        }
      });
    });
    promise.then((success) => {
      if (success) {
        this.id = this.displayUserData?.id;
        this.auth_key = this.displayUserData?.auth_key;
        this.loadCurso();
      }
    });
  }

  sanitizerUrl(): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl('https://api.whatsapp.com/send?text='+this.rutaRef);
  }
  ngOnInit() {
    console.log("Curso: ", this.curso);
    this.passwordCourse = this.curso.password;
    this.publico = this.curso.publico;
    this.activarContrasena = this.curso.pass;
    this.rutaRef = `${environment.urlFront}/cursos/estudiante-curso/${this.curso.id}`;
    // this.urlEncode = encodeURIComponent('visita este enlace'+this.rutaRef);
    this.urlEncode = this.sanitizerUrl();
    this.loadScript();
    this.loadUserData();
  }
  loadScript() {
    console.log("Load JS...");
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "assets/js/functions.js";
    document.body.appendChild(script);
  }
  setVista(id) {
    this.publico = id;
  }
  copyCodeCordova() {
    this.clipboard.copy(this.rutaRef);
    this.toastService.presentToast("Texto copiado al porta papeles");
  }
  async copyCode() {
    if (this.globalsService.platform.is("cordova")) {
      this.copyCodeCordova();
    } else {
      try {
        await navigator.clipboard.writeText(this.rutaRef);
        this.toastService.presentToast("Texto copiado al porta papeles");
      } catch (err) {
        console.error("Failed to copy: ", err);
      }
    }
  }

  activarPass(event) {
    let estado = parseInt(event.detail.value);
    this.activarContrasena = estado;
    this.passwordCourse = "";
    console.log("this.passActivo: ", this.activarContrasena);
  }

  descargar() {
    let src = jQuery("ngx-qrcode").find("img").attr("src");
    let b64String = src.split(/[ ,]+/)[1];

    let blobData = this.convertBase64ToBlobData(b64String);
    let filename = "qr-code" + this.curso.id;
    let contentType = "image/png";
    if (window.navigator && "msSaveOrOpenBlob" in window.navigator) {
      // Internet Explorer
      (window.navigator as any).msSaveOrOpenBlob(blobData, filename);
    } else {
      // chrome
      const blob = new Blob([blobData], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      // window.open(url);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      link.click();
    }
  }

  convertBase64ToBlobData(
    base64Data: string,
    contentType: string = "image/png",
    sliceSize = 512
  ) {
    // let base64Data = "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";
    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  guardarCurso() {
    if(this.activarContrasena == 1){
      if(this.passwordCourse == ""){
        this.alertConfirm("Error", "¡Debe ingresar una contraseña para el curso!");
        return;
      }

    }
    let id_curso = this.argumentos;
    const data = {
      auth_key: this.auth_key,
      id_curso: id_curso,
      id_usuario: this.id,
      nombre: this.curso.nombre,
      id_materia: this.curso.materia,
      id_nivel: this.curso.nivel,
      calificacion_min: this.curso.calificacionmin,
      id_calificacion: this.curso.idcalificacion,
      descripcion_curso: this.curso.detalles,
      imagen: this.curso.defaultImgFile,
      publico: this.publico,
      pass: this.activarContrasena,
      pass_value: this.passwordCourse,
      cod_certificado: 0,
    };
    this.cursosService.updateCurso(data).subscribe((response) => {
      let res = response;
      if (res.error == 0 && res.auth_key) {
        console.log("Guardar Curso respuesta: ", response);
        this.alertConfirm(
          "Hecho",
          "¡Los datos se registraron satisfactoriamente!"
        );
       
      } else {
        this.alertConfirm("Error", "¡Ocurrio un error. Inténtelo más tarde!");
      }
    });
  }
  async alertConfirm(titulo, mensaje) {
    const alert = await this.alertController.create({
      cssClass: "rm-book-alert",
      header: titulo,
      message: mensaje,
      buttons: [
        {
          text: "Aceptar",
          cssClass: "secondary",
          handler: (blah) => {
            if (titulo == "Hecho") {
              window.location.reload();
            }
          },
        },
      ],
    });

    await alert.present();
  }

  loadCurso() {
    this.actividadesService
      .getAllActividadesCursos(this.auth_key, this.argumentos)
      .subscribe((response) => {
        if (response !== undefined) this.ACTIVIDADES = response;
        this.CONTINUE = 0;

        if (this.ACTIVIDADES) {
          this.ACTIVIDADES.forEach((element, i) => {
            let ids: any = [];
            let id_libro_nodata = element.data.id;
            if (element.actividades.data != undefined) {
              element.actividades.activities.forEach((element, i) => {
                ids.push({
                  id_actividad: element[0].data.id_actividad,
                  id_tipo: element[0].data.id_tipo,
                });
              });
              let disponible = 1;
              let t_individual = 0;
              let t_individualArray = [];
              let calificable = 1;
              let o_aleatorio = 1;
              let id_libro = element.data.id;
              let tipo = 1;

              // if(!this.findValueInArrayOb(element.data.id,element)){
              // alert(element.data.id);
              // }
              let filtered;
              filtered = this.arrayExistIndex(id_libro, this.DATA_LIBRO);
              // if(filtered){
              //   console.log("FILTER Exist: "+id_libro);
              // }else{
              //   console.log("FILTER No exist: "+id_libro);
              // }
              if (!filtered)
                this.DATA_LIBRO.push({
                  actividades: ids,
                  //"id_tipo":element.actividades.activities[0][0].data.id_tipo,
                  disponible: disponible,
                  t_individual: t_individual,
                  t_individualArray: t_individualArray,
                  calificable: calificable,
                  o_aleatorio: o_aleatorio,
                  id_libro: id_libro,
                  tipo: tipo,
                });
            } else {
              let filtered;
              filtered = this.arrayExistIndex(id_libro_nodata, this.DATA_LIBRO);
              if (!filtered)
                this.DATA_LIBRO.push({ id_libro: id_libro_nodata, tipo: 0 });
            }
            this.CONTINUE = this.ACTIVIDADES.length;
          });
        }

        // getActividadCurso
        this.cursosService
          .getActividadCurso(this.id, this.curso.id, this.auth_key)
          .subscribe((res: any) => {
            if (!res.error) {
              this.ACTIVIDAD_CURSO = res;

              if (this.ACTIVIDAD_CURSO) {
                let ids_c: any = {};
                this.ACTIVIDAD_CURSO.forEach((element) => {
                  ids_c = {};
                  if (element.size > 0) {
                    element.activities.forEach((element2) => {
                      ids_c = {
                        id_actividad: element2.data.id_actividad,
                        id_tipo: element2.data.id,
                      };
                    });
                  }
                  let id_curso = element.data[0].id;
                  let filtered;
                  filtered = this.arrayExistIndexCurso(
                    id_curso,
                    this.DATA_CURSO
                  );
                  // if(filtered){
                  //   console.log("FILTER Exist: "+id_curso);
                  // }else{
                  //   console.log("FILTER No exist: "+id_curso+"rr");
                  // }
                  if (!filtered) {
                    this.DATA_CURSO.push({
                      id: element.data[0].id,
                      actividades: ids_c,
                      disponible: 1,
                      t_individual: 0,
                      t_individualArray: [],
                      calificable: 1,
                      o_aleatorio: 1,
                      id_curso: element.id_curso,
                      tipo: 2,
                    });
                  }
                });
              } else {
              }
            }
          });
        console.log("1 this.DATA_LIBRO: ", this.DATA_LIBRO);
        console.log("2 this.DATA_CURSO: ", this.DATA_CURSO);
      });
  }

  async presentAlertConfirmEndCurse() {
    const alert = await this.alertController.create({
      cssClass: "my-custom-class",
      header: "Confirmar",
      message: "¿Desea finalizar el curso?",
      buttons: [
        {
          text: "Cancelar",
          role: "cancel",
          cssClass: "secondary",
          handler: (blah) => {},
        },
        {
          text: "Aceptar",
          handler: () => {
            this.endCurse();
          },
        },
      ],
    });

    await alert.present();
  }

  endCurse() {
    let id_curso = this.argumentos;
    const data = {
      auth_key: this.auth_key,
      id_usuario: this.id,
      id_curso: id_curso,
    };
    this.cursosService.endCurse(data).subscribe((response) => {
      let res = response;
      if (res.error == 0 && res.auth_key) {
        window.location.reload();
        this.alertConfirm("Hecho", "¡El curso se finalizo correctamente!");
      } else {
        this.alertConfirm("Error", "¡Ocurrio un error. Inténtelo más tarde!");
      }
    });
  }

  arrayExistIndex(valor, array) {
    let filtered = false;
    array.forEach((element, i, array) => {
      // console.log('FILTER: ',element.id_libro);
      // console.log('FILTER valor: ',valor);
      if (element.id_libro == valor) {
        filtered = true;
      }
      if (i == array.length - 1) {
      }
    });
    return filtered;
  }
  arrayExistIndexCurso(valor, array) {
    let filtered = false;
    array.forEach((element, i, array) => {
      // console.log('FILTER: ',element.id_libro);
      // console.log('FILTER valor: ',valor);
      if (element.id == valor) {
        filtered = true;
      }
      if (i == array.length - 1) {
      }
    });
    return filtered;
  }

  actualizarDatosCurso(datos: any) {
    this.curso = datos;
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  generateInvitation() {
    let id_curso = this.argumentos;
    const data = {
      auth_key: this.auth_key,
      id_usuario: this.id,
      id_curso: id_curso,
    };
    this.cursosService.generateInvitation(data).subscribe(
      (response: Blob) => {
        const url = window.URL.createObjectURL(response);
        window.open(url);
      },
      (error) => {
        this.alertConfirm("Error", "¡Ocurrio un error. Inténtelo más tarde!");
      }
    );
  }
}
